var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2191 5.66281L4.18156 0.947189C4.16578 0.934768 4.14682 0.92705 4.12686 0.924919C4.10689 0.922788 4.08673 0.926332 4.06869 0.935143C4.05065 0.943955 4.03546 0.957676 4.02486 0.974732C4.01426 0.991787 4.0087 1.01149 4.00879 1.03156V2.06683C4.00879 2.13246 4.03959 2.1954 4.09049 2.23558L8.91192 6.00031L4.09049 9.76505C4.03825 9.80522 4.00879 9.86817 4.00879 9.9338V10.9691C4.00879 11.0588 4.11192 11.1083 4.18156 11.0534L10.2191 6.33781C10.2704 6.29779 10.3119 6.24658 10.3404 6.1881C10.369 6.12962 10.3838 6.06539 10.3838 6.00031C10.3838 5.93523 10.369 5.87101 10.3404 5.81253C10.3119 5.75404 10.2704 5.70284 10.2191 5.66281Z",
    fill: "black",
    fillOpacity: 0.88
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightActive);
export default __webpack_public_path__ + "static/media/RightActive.c22facb4ab9d93529ddfc76c018d666d.svg";
export { ForwardRef as ReactComponent };